import React from 'react';
import { AttendeeCreationAction, EmailAction } from './Actions'; // eslint-disable-line

const ACTIONS = [
    { type: 'email_action', component: EmailAction },
    { type: 'attendee_creation_action', component: AttendeeCreationAction }
];

export const ALLOWED_ACTIONS = ACTIONS.flatMap(ac => ['', ac.type]);

class TransitionActionHandler {
    #action;
    #actions;
    #component;

    constructor(action) {
        this.#action = action;
        this.#actions = ACTIONS;
        this.#component = this.#actions.find(act => act.type === this.#action.type);
    }

    validate() {
        if (!this.#component) {
            throw new Error(`${this.#action} is not valid, please provide a valid action`);
        }
    }

    get component() {
        this.validate();
        return this.#component.component;
    }
}

/**
 * TransitionActionHandler entry point
 * @param {Object} action - Action object
 * @param {Function} handleAction - Action properties setter
 * @returns {React.Component} Transition action main block
 */
const TransitionActionComponent = ({ action, index, handleAction, options }) => {
    if (!action || !action.type) {
        return null;
    }
    const ActionComponent = new TransitionActionHandler(action).component;
    return <ActionComponent action={action} index={index} handleAction={handleAction} options={options} />;
};

export default TransitionActionComponent;
